// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){
	// Handle menu interactions
	// Handle the mobile menu toggling
	$('#nav-icon').click(function() {
		mainNav();
	});

	function mainNav() {
		$('.main-menu-toggle').toggleClass('cross');
		$('body').toggleClass(function(){
		  return $(this).is('.modal-open, .modal-close') ? 'modal-open modal-close' : 'modal-open';
		});
		
	        if ($(document).scrollTop() < 120) {
	            $('.modal-open .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo.svg');
	        }

	        else {
				$('.modal-close .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo-light.svg');
				$('.modal-open .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo.svg');
	        }


		$('#site-navigation').toggleClass('open');
		$("#secondary-navigation").toggleClass("open");
	}

	function closeMainNav() {
		$('.main-menu-toggle').removeClass('cross');
		$('body').removeClass('modal-open');
		$('#site-navigation').removeClass('open');
		$("#secondary-navigation").removeClass("open");
	}

	/**
	 * Close the menu when a modal link is opened
	 */
	$(document).on('click', 'a.open-popup-link, .open-popup-link > a, .open a', function(e) {
		closeMainNav();
	});

})(jQuery);
